<div class="app flex-row align-items-center bg-login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <h1 class="font-weight-bold text-muted">パスワード再設定</h1>
              <p class="text-muted mb-4">新しいパスワードをご入力ください。</p>
              <div class="mb-4 text-danger">
                @if (data.password && !passwordValid) {
                  <label>パスワードは8文字以上16文字以下で入力してください。</label>
                }
                @if (confirmPassword && !passwordsMatch) {
                  <label>パスワードが一致しません。</label>
                }
              </div>
              <form novalidate #myForm="ngForm">
                <div class="input-group mb-4">
                  <div class="input-group-prepend d-none d-sm-flex">
                    <span class="input-group-text bg-login-input"><i class="fa fa-lock text-white"></i></span>
                  </div>
                  <input type="password" class="form-control" [(ngModel)]="data.password" name="password" required autocomplete="off" placeholder="新しいパスワード: 8～16文字">
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend d-none d-sm-flex">
                    <span class="input-group-text bg-login-input"><i class="fa fa-lock text-white"></i></span>
                  </div>
                  <input type="password" class="form-control" [(ngModel)]="confirmPassword" name="confirmPassword" required autocomplete="off" placeholder="新しいパスワード(確認)">
                </div>
                <div class="row">
                  <div class="col-12 text-right">
                    <button type="button" class="btn btn-primary px-4 text-white"
                            [disabled]="myForm.invalid || !passwordValid || !passwordsMatch"
                            data-toggle="modal" data-target="#passwordEditModal">
                      <i class="fa s-icon-reset"></i> 再設定
                    </button>
                  </div>
                </div>
              </form>

              <!-- Modal -->
              <div class="modal fade" id="passwordEditModal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">&nbsp;確認</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body"><p>パスワードを再設定します。<br></p></div>
                    <div class="modal-footer">
                      <button class="btn bg-close text-white" type="button" data-dismiss="modal"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
                      <button (click)="resetNow()" class="btn btn-primary text-white" data-dismiss="modal"><i class="fa s-icon-reset"></i>&nbsp;実行</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
